import { Col, Container, Row } from 'styled-bootstrap-grid';
import { Helmet } from 'react-helmet';
import Picture from '../../Picture/components/Picture';
import React, {Fragment, useEffect, useState} from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PageTitle from "../../PageTitle/components/PageTitle";
import ViewMoreLink from "../../ViewMoreLink/components/ViewMoreLink";
import { client } from '../../Utils/Prismic';
import { RichText } from 'prismic-reactjs';
import Prismic from 'prismic-javascript'
import HtmlRenderer from '../../HtmlRenderer/components/HtmlRenderer'
import { image, sources } from '../../HtmlRenderer/components/Image';
import Loader from '../../Utils/Loader';
// import PageNavigation from "../../PageNavigation/components/PageNavigation";
import RickshawBags from "./CaseStudy/RickshawBags";
import VerizonHum from "./CaseStudy/VerizonHum";
import CharmingCharlie from "./CaseStudy/CharmingCharlie";
import NoCompromiseGaming from "./CaseStudy/NoCompromiseGaming";
import BlackOvis from "./CaseStudy/BlackOvis";
import Heb from "./CaseStudy/Heb";
import AnovaFurnishings from "./CaseStudy/AnovaFurnishings";
import Cbdmd from "./CaseStudy/Cbdmd";
import HankyPanky from "./CaseStudy/HankyPanky";
import LobsterGram from "./CaseStudy/LobsterGram";

const ImgCol = styled(Col)`
  img {
    margin-bottom: 1rem;
    width: 100%;
  }
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const CaseStudy = (props) => {
  const [docs, setDocsData] = useState(null);
  useEffect(() => {
    const fetchDocsData = async () => {
      const response = await client.query(
          Prismic.Predicates.at('document.type', 'case_study'),
          { orderings : '[my.case_study.position]' }
      );
      if (response) {
        setDocsData(response.results);
      }
    };
    fetchDocsData();
  }, []);
  let caseStudy, prevCaseStudy, nextCaseStudy;
  if (docs && docs.length > 0) {
    const current = docs.findIndex((item) => item.uid === props.match.params.caseStudy);
    if (current !== -1) {
      caseStudy = docs[current].data;
      prevCaseStudy = (current === 0) ? docs[(docs.length - 1)] : docs[(current - 1)];
      nextCaseStudy = (current === (docs.length - 1)) ? docs[0] : docs[(current + 1)];
    }
  }

  if (props.match.params.caseStudy === 'rickshaw-bagworks') {
    return <RickshawBags />;
  }
  if (props.match.params.caseStudy === 'hum-by-verizon') {
    return <VerizonHum />;
  }
  if (props.match.params.caseStudy === 'charming-charlie') {
    return <CharmingCharlie />;
  }
  if (props.match.params.caseStudy === 'no-compromise-gaming') {
    return <NoCompromiseGaming />;
  }
  if (props.match.params.caseStudy === 'black-ovis') {
    return <BlackOvis />;
  }
  if (props.match.params.caseStudy === 'h-e-b') {
    return <Heb />;
  }
  if (props.match.params.caseStudy === 'anova-furnishings') {
    return <AnovaFurnishings />;
  }
  if (props.match.params.caseStudy === 'cbdmd') {
    return <Cbdmd />;
  }
  if (props.match.params.caseStudy === 'hanky-panky') {
    return <HankyPanky />;
  }
  if (props.match.params.caseStudy === 'lobster-gram') {
    return <LobsterGram />;
  }

  if (caseStudy) {
    return <Fragment>
      <Helmet>
        <meta name="description" content=""/>
        <title>Case Study: {caseStudy.title} | RMG</title>
        <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
      </Helmet>
      <PageTitle heading="Case Study"
                 subHeading={caseStudy.title}
      />
      <Container>
        <Row>
          <ImgCol col={12}>
            <Picture alt={caseStudy.title} defaultSource={image(caseStudy)} sources={sources(caseStudy)}/>
          </ImgCol>
        </Row>
        <Row>
          <Col col={12} md={6}>
            <HtmlRenderer render={RichText.asText(caseStudy.description[0].text)}/>
          </Col>
          <Col col={12} md={6}>
            <HtmlRenderer render={RichText.asText(caseStudy.description[1].text)}/>
          </Col>
        </Row>
        <Row>
          <NavCol col={12}>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                          to={`/portfolio/${prevCaseStudy.uid}`}
                          buttonText={prevCaseStudy.data.title}/>
            <NavSpan>/</NavSpan>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/${nextCaseStudy.uid}`}
                          buttonText={nextCaseStudy.data.title}/>
          </NavCol>
        </Row>
      </Container>
    </Fragment>;
  } else {
    return <Fragment>
      <Helmet>
        <meta name="description" content=""/>
        <title>User Experiences We Created for Our Clients | RMG</title>
        <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
      </Helmet>
      <PageTitle heading="Case Study"/>
      <Container>
        <Row>
          <Loader minHeight="51vh" top="40%"/>
        </Row>
      </Container>
    </Fragment>;
  }
};

export default withRouter(CaseStudy);
